import { createContext } from "react";
import { RecordStatus } from "../../../common/data/service-proxies";

export const SELECTED_VEHICLES_UPDATED = "SELECTED_VEHICLES_UPDATED";
export const SELECTED_DRIVERS_UPDATED = "SELECTED_DRIVERS_UPDATED";

export interface ISelectedDriverOrVehicle {
  id: number;
  name: string;
  status: RecordStatus;
}

export interface IGroupMembersContext {
  selectedDrivers: Array<ISelectedDriverOrVehicle>;
  selectedVehicles: Array<ISelectedDriverOrVehicle>;
}

export interface IGroupMembersAction {
  type: string;
  payload: Array<ISelectedDriverOrVehicle>;
}

export const GroupMembersContext = createContext<IGroupMembersContext>({
  selectedDrivers: [],
  selectedVehicles: [],
});

export const groupMembersReducer = (
  state: IGroupMembersContext,
  action: IGroupMembersAction
) => {
  switch (action.type) {
    case SELECTED_DRIVERS_UPDATED:
      return { ...state, selectedDrivers: action.payload };
    case SELECTED_VEHICLES_UPDATED:
      return { ...state, selectedVehicles: action.payload };
  }

  return state;
};
